import { Button, Popover, Row, Space } from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  Notification,
} from "components/common";
import dayjs from "dayjs";
import {
  exportFile,
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import React, { useEffect, useRef, useState } from "react";
import { ColumnsEdit } from "types/models/column-table-edit";
import { columnss, itemsInputField } from "./ReportWaittingAnalysis.config";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { ListIconSVG } from "assets";
import residentialNurse from "redux/reducer/residentialNurse";
import { FORMAT_TIME, tabKeys } from "types/enums";
import { useAppSelector } from "redux/hooks";
import { analysisService } from "api";

const ReportWaittingAnalysis = () => {
  let savedTableOption = getTableOptions(
    "TREATMENT_TABLE",
    localStorage.getItem("username")
  );

  const defaultColumns = savedTableOption
    ? columnss.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : columnss;
  const activeTab = useAppSelector((e) => e.common.activeTab);

  const expandRef = useRef<any>();
  const [columns, setColumns] = useState<ColumnsEdit>(
    defaultColumns.filter((e) => e.show == true)
  );
  const [data, setData] = useState<any>([]);

  const [limit, setLimit] = useState<number>(20);

  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const [params, setParams] = useState<any>({
    start: dayjs().set("hour", 0).set("minute", 0).set("second", 0),
    end: dayjs().set("hour", 23).set("minute", 59).set("second", 59),
  });

  const formatParams = () => {
    return {
      start: formatDateToString(params.start, FORMAT_TIME.dateTime_invert),
      end: formatDateToString(params.end, FORMAT_TIME.dateTime_invert),
    };
  };
  const getWattingReportAnalysis = async () => {
    try {
      setLoading(true);
      let response = await analysisService.getWattingReportAnalysis(
        formatParams()
      );

      setData(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      Notification("error", "Lấy danh sách báo cáo không thành công");
    }
  };
  const onClickSearchButton = () => {
    const searchFields = expandRef.current?.getData();

    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
    setPage(1);
  };

  useEffect(() => {
    if (activeTab === tabKeys.ANALYSIS.REPORT_WAITTING_ANALYSIS) {
    }
    getWattingReportAnalysis();
  }, [params, activeTab]);
  const onKeyDown = async (e) => {
    if (e.key === "Enter") {
      await setTimeout(() => {
        onClickSearchButton();
      }, 500);
    }
  };
  const setShowColumns = (showColumns) => {
    saveTableOptions(
      "TREATMENT_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const handleRow = async (record) => {};

  const onPaginationChange = (page, pageSize) => {
    setPage(page);
    setLimit(pageSize);
  };
  columns.find((e) => e.dataIndex === "index").render = (v, r, i) =>
    (page - 1) * limit + i + 1;
  //XUất báo cáo
  const getReportFile = async () => {
    const param = formatParams();

    if (param?.start != null || param.end !== null) {
      exportFile(
        "/qlkhambenh/phieu-xet-nghiem/export-bao-cao-thoi-gian-xet-nghiem",
        formatParams(),
        `Báo cáo thống kê thời gian xét nghiệm`
      );
    } else {
      Notification("error", "");
    }
  };
  return (
    <div>
      <div className="container" onKeyDown={onKeyDown}>
        <ExpandSearch
          ref={expandRef}
          onClickSearch={onClickSearchButton}
          fields={itemsInputField}
          onReset={onClickSearchButton}
          initialValues={params}
          isResetField={false}
          isShowDetail={true}
          isSearch={false}
          isSearchExpend={false}
          isExportExcel={true}
          handleExportExcel={getReportFile}
        ></ExpandSearch>
      </div>
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
            </Space>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            rowKey={(record) => record.id}
            bordered
            dataSource={data.map((e, i) => ({
              ...e,
              key: i,
            }))}
            loading={loading}
            pagination={{
              pageSize: limit,
              current: page,
              onChange: onPaginationChange,
              showSizeChanger: true,
            }}
            onRow={(record) => ({
              onDoubleClick: () => handleRow(record),
            })}
            columns={columns}
            // rowSelection={{
            //   type: "radio",
            //   onChange: onSelectRow,
            // }}
          />
        </Space>
      </div>
    </div>
  );
};

export default ReportWaittingAnalysis;
